/* src/app/views/area-publica/detalhes-projeto/maturidade/detalhes-maturidade-setor-public/detalhes-maturidade-setor-public.component.scss */
.grafico-data {
  width: 50% !important;
  max-width: 50% !important;
  padding-right: 30px;
  justify-content: space-between;
}
.container-maturidade {
  background: #FFFFFF 0% 0% no-repeat padding-box;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1607843137);
  border-radius: 4px;
  padding: 40px;
  margin: 20px;
}
.titulo-grafico {
  text-align: left;
  font: normal normal bold 20px/24px "Montserrat", sans-serif;
  letter-spacing: 0px;
  color: #2E3241;
  margin: 0;
  margin-top: 20px;
}
.estagio-maturidade {
  text-align: left;
  font: normal normal bold 41px/0px Montserrat, sans-serif;
  letter-spacing: 0px;
  color: #007AC2;
  margin-top: 24px;
  margin-bottom: 0;
}
span {
  font: normal normal normal 14px/18px Montserrat, sans-serif;
  letter-spacing: 0px;
  color: #2E3241;
  overflow-wrap: break-word;
}
.nota-maturidade {
  text-align: left;
  font: normal normal normal 41px/50px "Montserrat", sans-serif;
  letter-spacing: 0px;
  color: #007AC2;
}
.subtitulo-grafico {
  text-align: left;
  font: normal normal normal 16px/0px "Montserrat", sans-serif;
  font-weight: 500;
  letter-spacing: 0px;
  color: #757575;
  margin: 0;
  margin-top: 10px;
}
.resumo-grafico-container {
  border-width: 0;
  border-bottom-width: 2px;
  border-bottom-color: rgba(0, 122, 194, 0.1);
  padding-bottom: 16px;
  border-top-width: 2px;
  border-top-color: rgba(0, 122, 194, 0.1);
  padding-top: 16px;
  border-style: solid;
}
.maturidade-detail {
  border: 1px solid #DBE3F2;
  border-radius: 4px;
}
.maturidade-detail-header {
  font-size: 16px;
  font-weight: 500;
  background: #DBE3F2 0% 0% no-repeat padding-box;
  margin-bottom: 0 !important;
}
.maturidade-detail-header-margin {
  margin: 0.5% 2%;
}
.maturidade-detail-body {
  font-size: 16px;
  font-weight: 500;
  color: #2E3241;
  margin-bottom: 0 !important;
}
.maturidade-detail-body-margin {
  margin: 0.5% 2%;
  margin-bottom: 0 !important;
  margin-top: 0 !important;
}
.header-table-detalhes-maturidade {
  text-align: center;
  color: #007AC2;
}
.first-column {
  border-left: 1px solid #DBE3F2;
  padding-bottom: 16px;
}
.txt-center {
  text-align: center;
}
.txt-left {
  text-align: left;
}
.txt-right {
  text-align: right;
}
.cell {
  padding: 16px 12px 12px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.cell .first {
  padding-bottom: 10px;
}
.container-header {
  text-align: center;
}
.header-dados-integrante {
  text-align: center;
  font: normal normal bold 16px/19px Montserrat, sans-serif;
  letter-spacing: 0px;
  color: #7A7A7A;
  padding-right: 11px;
}
.container-header-tabela-dados-integrantes {
  padding: 10px 20px 10px 20px;
  align-items: center;
}
.row-dados-vertente {
  padding: 20px;
  border-top: 2px solid #bbb4b4;
}
.grey-line {
  background-color: #FAFAFA;
}
.white-line {
  background-color: #FFFFFF;
}
.label-vertente {
  text-align: right;
  font: normal normal 600 16px/19px Montserrat, sans-serif;
  letter-spacing: 0px;
  color: #7A7A7A;
}
.txt-right-dados-vertente {
  text-align: right;
}
.coluna-dados-vertentes {
  padding-right: 11px;
  align-items: center !important;
  border-right: 2px solid #bbb4b4;
}
.maturidade-integrante {
  text-align: center;
  align-self: center;
}
.item-dados-vertente-subvertente {
  padding: 10px;
  padding-top: 0;
  padding-left: 0;
  align-items: center;
}
.no-padding-right {
  padding-right: 0 !important;
}
.display-block {
  display: block;
}
.container-header-padding {
  padding-left: 20px;
}
.nome-setor {
  text-align: left;
  font: normal normal bold 20px/24px Montserrat, sans-serif;
  letter-spacing: 0px;
  color: #007AC2;
  position: relative;
}
.nome-setor::before {
  content: "";
  display: inline-block;
  width: 8px;
  height: 8px;
  -moz-border-radius: 100%;
  -webkit-border-radius: 100%;
  border-radius: 100%;
  background-color: #007AC2;
  margin-right: 8px;
  margin-bottom: 3px;
}
.grafico-subtitle {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-grow: 2;
}
@media only screen and (max-width: 1679px) {
  .container-dados-maturidade {
    flex-direction: column !important;
  }
  .grafico-subtitle {
    flex-direction: row;
  }
  .maturidade-detail {
    align-self: flex-end;
  }
  .grafico-data {
    width: 100% !important;
    max-width: 100% !important;
  }
  .container-tabela-dados {
    padding-top: 20px;
  }
}
.container-tabela-dados {
  border-radius: 8px;
  border: 2px solid #bbb4b4;
  padding-bottom: 3px;
}
.titulo-grafico-interno {
  display: none;
}
.grafico-container {
  margin: auto;
}
@media only screen and (min-width: 1366px) {
  .header-dados-integrante,
  .label-vertente {
    font-size: 16px;
  }
}
@media only screen and (min-width: 1680px) {
  .header-dados-integrante,
  .label-vertente {
    font-size: 14px;
  }
}
@media only screen and (min-width: 1920px) {
  .header-dados-integrante,
  .label-vertente {
    font-size: 16px;
  }
}
.accordion-maturidade {
  background-color: #FAFAFA;
  margin-bottom: 20px;
}
.grey-bg {
  background-color: #fbfbfb !important;
  margin-top: 8px;
  margin-bottom: 8px;
}
.title-accordion {
  font-size: 20px;
  line-height: 28px;
  margin-top: 0;
}
:host ::ng-deep .mat-expansion-panel:not([class*=mat-elevation-z]) {
  box-shadow: none;
}
:host ::ng-deep .mat-expansion-panel-body {
  padding: 0 5px 16px;
}
/*# sourceMappingURL=detalhes-maturidade-setor-public.component.css.map */
